module.exports = __webpack_public_path__ + "static/bankinvoice-9d53b5836a1f7b1ebc2ea200773e7acb.mp4";